import { FC, Suspense } from "react";

import { ShimmerUI } from "../ui/shimmer-ui";
import { DummyUI } from "./dummy-ui";
import { SuspenseErrorBoundary } from "./suspense-error-boundary";

export interface SuspenseShimmerWithUIProps {
  hideError?: boolean;
}

export const SuspenseShimmerWithUI: FC<SuspenseShimmerWithUIProps> = ({
  hideError,
  children,
}) => {
  return (
    <Suspense
      fallback={
        <DummyUI>
          <ShimmerUI />
        </DummyUI>
      }
    >
      <SuspenseErrorBoundary hideError={hideError}>
        {children}
      </SuspenseErrorBoundary>
    </Suspense>
  );
};
